import React from "react";
import axios from "axios";
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";
import { getDomainId } from "utils/utils";
import { getDomainIdSync } from "utils/utils";



const ExportE = ({ searchQuery = "", filename = "export.csv" , startDate, endDate , startDate1, endDate1}) => {
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return "";
      const stringValue = String(value)
        .replace(/<br\s*\/?>/gi, " ") // Replace <br> tags with space
        .replace(/[\r\n]+/g, " ")     // Remove newlines
        .replace(/"/g, '""');         // Escape double quotes

      return `"${stringValue}"`; // Enclose in quotes
    };

  const exportToCSV = async () => {
    try {
      const domainId = getDomainIdSync();
      // console.log("Domain ID:", domainId);
  
      const response = await axios.get(`${LAMBDA_BASE_URL}/emails-sent`, {
        params: {
          search: searchQuery,
          limit: 10000,
          page: 1,
          start_date : startDate,
          end_date : endDate,
        
        },
        headers: {
          "DOMAIN-TOKEN": domainId,
        },
      });

      const data = response?.data?.result?.emails_sent || [];

      if (!Array.isArray(data) || data.length === 0) {
        alert("No data to export");
        return;
      }

      const headers = ["email","ip_address","country","region","city","created_at"];
      const csvRows = [];

      // Add header row
      csvRows.push(headers.map(escapeCSV).join(","));

      // Add data rows
      data.forEach((row) => {
        const values = headers.map((header) => escapeCSV(row[header]));
        csvRows.push(values.join(","));
      });

      const csvContent = "\uFEFF" + csvRows.join("\n"); // UTF-8 BOM for Excel
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      alert("Export failed");
    }
  };

  return (
    <button
      onClick={exportToCSV}
           style={{
            padding: "10px 12px",
            borderRadius: "6px",
            background: "#219297",
            color: "white",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            maxWidth: "100%",
            boxShadow:
              "-2px 0 4px rgba(0,0,0,0.05), 2px 0 4px rgba(0,0,0,0.05), 0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: "600",
            transition: "filter 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
    >
      Export to CSV
    </button>
  );
};

export default ExportE;
